import { render } from "./viewWorkCard.vue?vue&type=template&id=51ecc50c&scoped=true"
import script from "./viewWorkCard.vue?vue&type=script&lang=js"
export * from "./viewWorkCard.vue?vue&type=script&lang=js"

import "./viewWorkCard.vue?vue&type=style&index=0&id=51ecc50c&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ecc50c"]])

export default __exports__